import React, { useEffect, useState } from "react";
import "./hairprp.css";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "./../../../assets/images/prp-hero.jpg"; // Add your image
import prp1 from "./../../../assets/images/prp1.jpg";
import prp2 from "./../../../assets/images/prp2.jpg";
import prp3 from "./../../../assets/images/prp3.jpg";
import prp4 from "./../../../assets/images/prp4.jpg";
function Hairprp() {
  const [ setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("GFC");
  const navigate = useNavigate();

  useEffect(() => {
    const steps = document.querySelectorAll('.prp-process-step');
    steps.forEach((step, index) => {
      step.style.setProperty('--index', index);
      step.style.opacity = '1';
    });
  }, []);

  return (
    <div className="prp-wrapper">
      {/* Unique Treatment Navigation Tabs */}
      <div className="prp-treatment-tabs">
        {["GROHAIR", "PRP","GFC","STM", "Laser"].map((tab) => (
          <div 
            key={tab} 
            className={`prp-treatment-tab ${activeTab === tab ? "prp-active" : ""}`}
            onClick={() => {
              setActiveTab(tab);
              navigate(`/home/${tab.toLowerCase()}`);
            }}
          >
            {tab} Treatment
          </div>
        ))}
      </div>
      <section 
        className="prp-hero" 
        style={{
          backgroundImage:`linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`
        }}
      >
        <div className="prp-hero-content">
          <h1 className="prp-hero-title">Revolutionary PRP Therapy for Hair Restoration</h1>
          <p className="prp-hero-text">
            Harness the power of your own platelets to naturally rejuvenate your scalp and restore hair density.
          </p>
          <Link to="/bookconsultation" style={{ textDecoration: "none" }} className="prp-cta-button">
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Treatment Section */}
      <section className="prp-treatment-section" id="treatments">
        <div className="prp-treatment-container">
        <div className="prp-treatment-nav">
            <h2>Revitalize Your Hair with Our Advanced Treatments</h2>
            <p className="prp-nav-description">
              From growth factor enhancements to exclusive prp therapies, each treatment is engineered to kickstart your natural hair regrowth.
            </p>
            <ul>
            <li className="prp-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps  in hair regrowth .</p>
                <ul className="prp-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
                
              </li>
   <li className="prp-active">
                <strong>Growth Factor Therapy</strong>
                <p>Stimulate hair follicles & helps  in hair regrowth .</p>
                <ul className="prp-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>Enrich with Biotin , Zinc , Minerals and other Vitamins</li>
                </ul>

              </li>
              <li>
                <strong>PRP Therapy</strong>
                <p>Restore your hair naturally by plasma rich protein therapy.</p>
                <ul className="prp-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>
              
              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="prp-treatment-details">
                  <li>Based on plant poly peptides </li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="prp-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="prp-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced specialists.
            </p>
            <p className="prp-treatment-extra-info">
              Book a consultation today to create your personalized treatment plan.
            </p>

          </div>

          <div className="prp-treatment-content">
            <h3>PRP Treatment</h3>
            <div className="prp-treatment-info">
              <div className="prp-treatment-images">
                <img
                  src={prp1}
                  alt="Growth Factor Treatment Process"
                  className="prp-main-treatment-image"
                />
                <div className="prp-treatment-gallery">
                  <img
                    src={prp2}
                    alt="Before and After Results"
                  />
                  <img
                    src={prp3}
                    alt="Treatment Procedure"
                  />
                  <img
                    src={prp4}
                    alt="Advanced Equipment"
                  />
                </div>
              </div>

              <div className="prp-treatment-description">
                <h4>Empowering Hair Regrowth with Science</h4>
                <div className="prp-treatment-intro">
                  <span className="prp-highlight-tag">Innovative PRP</span>
                  <p className="prp-lead-text">
                    Our breakthrough technology fuses advanced growth factors with your body's own healing proteins to restore thicker, healthier hair.
                  </p>
                </div>

                <div className="prp-key-benefits">
                  <h5>Transformative Benefits of Our PRP Approach</h5>
                  <p>
                    Our method leverages state-of-the-art PRP technology to:
                  </p>
                  <ul>
                    <li>
                      <span className="prp-benefit-icon">🔬</span>
                      <strong>Revitalize Dormant Follicles</strong>
                      <p>Autologous treatment.</p>
                    </li>
                    <li>
                      <span className="prp-benefit-icon">📈</span>
                      <strong>Boost Hair Density</strong>
                      <p>No synthetic additives.</p>
                    </li>
                    <li>
                      <span className="prp-benefit-icon">🌱</span>
                      <strong>Promote Natural Regeneration</strong>
                      <p>Boosts regeneration.</p>
                    </li>
                    <li>
                      <span className="prp-benefit-icon">💪</span>
                      <strong>Strengthen Existing Hair</strong>
                      <p>Reduce breakage and revitalize hair quality.</p>
                    </li>
                  </ul>
                </div>

                <div className="prp-treatment-highlights">
                  <div className="prp-highlight-box">
                    <h5>Client Success Rate</h5>
                    <p>95%</p>
                    <span className="prp-subtitle">Satisfied Clients</span>
                  </div>
                  <div className="prp-highlight-box">
                    <h5>Session Duration</h5>
                    <p>60 mins</p>
                    <span className="prp-subtitle">Per Treatment</span>
                  </div>
                  <div className="prp-highlight-box">
                    <h5>Minimal Recovery</h5>
                    <p>Quick</p>
                    <span className="prp-subtitle">Rapid Return to Routine</span>
                  </div>
                  <div className="prp-highlight-box">
                    <h5>Result</h5>
                    <p>6-10 sessions</p>
                    <span className="prp-subtitle">for visible results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="prp-book-treatment-btn">
                    Schedule Your Free Consultation
                    <span className="prp-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advanced PRP Content Section */}
      {activeTab === "PRP" && (
        <section className="prp-advanced-section" id="advanced-prp">
          <div className="prp-advanced-header">
            <h2>Advanced PRP Insights</h2>
            <p className="prp-advanced-subtitle">
              Discover the science behind our Platelet Rich Plasma Therapy. We harness your own platelets to boost cell regeneration, improve tissue repair, and stimulate natural hair growth.
            </p>
          </div>
          <div className="prp-advanced-content">
            <div className="prp-advanced-image">
              <img
                src="https://images.unsplash.com/photo-1581093448798-85b2a7d852e7?q=80"
                alt="Advanced PRP Treatment Process"
              />
            </div>
            <div className="prp-advanced-details">
              <h3>How Our PRP Process Works</h3>
              <ul>
                <li>
                  <strong>Platelet Concentration:</strong> We extract and concentrate the healing components in your blood for maximum efficacy.
                </li>
                <li>
                  <strong>Precision Delivery:</strong> Customized injections target thinning areas to stimulate dormant hair follicles.
                </li>
                <li>
                  <strong>Natural Regeneration:</strong> Enjoy an entirely natural method of promoting hair growth with minimal downtime.
                </li>
                <li>
                  <strong>Tailored Treatment Plans:</strong> Every session is adapted to your unique hair needs and treatment goals.
                </li>
              </ul>
            </div>
          </div>
          <button className="prp-cta-button" onClick={() => setIsModalOpen(true)}>
            Discover PRP Benefits &amp; Book Your Consultation
          </button>
        </section>
      )}

      {/* Benefits Section */}
      <section className="prp-benefits-section">
        <div className="prp-benefits-header">
          <span className="prp-section-tag">Why Choose Us</span>
          <h2>Experience the H-Cura Difference</h2>
          <p className="prp-section-subtitle">
            Our advanced treatments combine cutting-edge science with personalized care to restore your hair and confidence.
          </p>
        </div>
        <div className="prp-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in PRP and growth factor science to deliver natural hair regeneration results.",
              features: [
                "Innovative Treatment Protocols",
                "FDA-Approved Procedures",
                "Clinically Proven Results",
              ],
            },
            {
              icon: "👨‍⚕",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists are experts in hair restoration and are dedicated to your care.",
              features: [
                "Highly Trained Professionals",
                "Years of Experience",
                "Personalized Attention",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is tailored to your genetic profile and hair restoration goals.",
              features: [
                "Individualized Sessions",
                "Continuous Progress Tracking",
                "Optimized Treatment Frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve fuller, healthier hair that looks completely natural with our PRP solutions.",
              features: [
                "Subtle Enhancements",
                "Long-Lasting Benefits",
                "Effortless Aesthetics",
              ],
            },
            {
              icon: "🛡",
              title: "Safety First",
              desc: "Our treatments meet the highest medical standards, ensuring a safe and sterile environment at all times.",
              features: [
                "Medical-Grade Facilities",
                "Strict Safety Protocols",
                "Patient-Centric Care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of clients who have experienced astonishing hair regeneration results with H-Cura.",
              features: [
                "Over 5000 Happy Clients",
                "Remarkable Clinical Outcomes",
                "Consistently High Success Rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="prp-benefit-card" key={index}>
              <div className="prp-benefit-icon">{benefit.icon}</div>
              <div className="prp-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="prp-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="prp-process-section" id="process">
        <div className="prp-process-header">
          <span className="prp-process-tag">Our Process</span>
          <h2>Your Journey to Fuller Hair with H-Cura</h2>
          <p className="prp-process-subtitle">
            Embrace our comprehensive 4-step approach for sustainable hair restoration.
          </p>
        </div>
        <div className="prp-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your scalp health and treatment goals.",
              details: [
                "Detailed scalp analysis",
                "Personal health review",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our team collaborates with you to design a bespoke PRP treatment plan that best suits your hair needs.",
              details: [
                "Personalized regimen design",
                "Optimized platelet extraction",
                "Session scheduling",
                "Lifestyle coaching",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert PRP Session",
              desc: "Experience our precise injection techniques as we apply concentrated platelets to trigger natural regrowth.",
              details: [
                "Sterile preparation",
                "Precision PRP injection",
                "Targeted hair follicle activation",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care, ensuring your progress is monitored and optimized.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment refinement",
                "Maintenance plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="prp-process-step" key={index}>
              <div className="prp-step-container">
                <div className="prp-step-number-container">
                  <div className="prp-step-number">{process.step}</div>
                  <div className="prp-step-icon">{process.icon}</div>
                </div>
                <div className="prp-step-content">
                  <h3>{process.title}</h3>
                  <p className="prp-step-description">{process.desc}</p>
                  <ul className="prp-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="prp-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>
      
    </div>
  );
}

export default Hairprp;